const countryCodes = [
  {
    alpha3: 'AFG',
    alpha2: 'AF',
    name: 'Afghanistan',
  },
  {
    alpha3: 'ALA',
    alpha2: 'AX',
    name: 'Åland Islands',
  },
  {
    alpha3: 'ALB',
    alpha2: 'AL',
    name: 'Albania',
  },
  {
    alpha3: 'DZA',
    alpha2: 'DZ',
    name: 'Algeria',
  },
  {
    alpha3: 'ASM',
    alpha2: 'AS',
    name: 'American Samoa',
  },
  {
    alpha3: 'AND',
    alpha2: 'AD',
    name: 'Andorra',
  },
  {
    alpha3: 'AGO',
    alpha2: 'AO',
    name: 'Angola',
  },
  {
    alpha3: 'AIA',
    alpha2: 'AI',
    name: 'Anguilla',
  },
  {
    alpha3: 'ATA',
    alpha2: 'AQ',
    name: 'Antarctica',
  },
  {
    alpha3: 'ATG',
    alpha2: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    alpha3: 'ARG',
    alpha2: 'AR',
    name: 'Argentina',
  },
  {
    alpha3: 'ARM',
    alpha2: 'AM',
    name: 'Armenia',
  },
  {
    alpha3: 'ABW',
    alpha2: 'AW',
    name: 'Aruba',
  },
  {
    alpha3: 'AUS',
    alpha2: 'AU',
    name: 'Australia',
  },
  {
    alpha3: 'AUT',
    alpha2: 'AT',
    name: 'Austria',
  },
  {
    alpha3: 'AZE',
    alpha2: 'AZ',
    name: 'Azerbaijan',
  },
  {
    alpha3: 'BHS',
    alpha2: 'BS',
    name: 'Bahamas',
  },
  {
    alpha3: 'BHR',
    alpha2: 'BH',
    name: 'Bahrain',
  },
  {
    alpha3: 'BGD',
    alpha2: 'BD',
    name: 'Bangladesh',
  },
  {
    alpha3: 'BRB',
    alpha2: 'BB',
    name: 'Barbados',
  },
  {
    alpha3: 'BLR',
    alpha2: 'BY',
    name: 'Belarus',
  },
  {
    alpha3: 'BEL',
    alpha2: 'BE',
    name: 'Belgium',
  },
  {
    alpha3: 'BLZ',
    alpha2: 'BZ',
    name: 'Belize',
  },
  {
    alpha3: 'BEN',
    alpha2: 'BJ',
    name: 'Benin',
  },
  {
    alpha3: 'BMU',
    alpha2: 'BM',
    name: 'Bermuda',
  },
  {
    alpha3: 'BTN',
    alpha2: 'BT',
    name: 'Bhutan',
  },
  {
    alpha3: 'BOL',
    alpha2: 'BO',
    name: 'Bolivia (Plurinational State of)',
  },
  {
    alpha3: 'BES',
    alpha2: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    alpha3: 'BIH',
    alpha2: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    alpha3: 'BWA',
    alpha2: 'BW',
    name: 'Botswana',
  },
  {
    alpha3: 'BVT',
    alpha2: 'BV',
    name: 'Bouvet Island',
  },
  {
    alpha3: 'BRA',
    alpha2: 'BR',
    name: 'Brazil',
  },
  {
    alpha3: 'IOT',
    alpha2: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    alpha3: 'BRN',
    alpha2: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    alpha3: 'BGR',
    alpha2: 'BG',
    name: 'Bulgaria',
  },
  {
    alpha3: 'BFA',
    alpha2: 'BF',
    name: 'Burkina Faso',
  },
  {
    alpha3: 'BDI',
    alpha2: 'BI',
    name: 'Burundi',
  },
  {
    alpha3: 'CPV',
    alpha2: 'CV',
    name: 'Cabo Verde',
  },
  {
    alpha3: 'KHM',
    alpha2: 'KH',
    name: 'Cambodia',
  },
  {
    alpha3: 'CMR',
    alpha2: 'CM',
    name: 'Cameroon',
  },
  {
    alpha3: 'CAN',
    alpha2: 'CA',
    name: 'Canada',
  },
  {
    alpha3: 'CYM',
    alpha2: 'KY',
    name: 'Cayman Islands',
  },
  {
    alpha3: 'CAF',
    alpha2: 'CF',
    name: 'Central African Republic',
  },
  {
    alpha3: 'TCD',
    alpha2: 'TD',
    name: 'Chad',
  },
  {
    alpha3: 'CHL',
    alpha2: 'CL',
    name: 'Chile',
  },
  {
    alpha3: 'CHN',
    alpha2: 'CN',
    name: 'China',
  },
  {
    alpha3: 'CXR',
    alpha2: 'CX',
    name: 'Christmas Island',
  },
  {
    alpha3: 'CCK',
    alpha2: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    alpha3: 'COL',
    alpha2: 'CO',
    name: 'Colombia',
  },
  {
    alpha3: 'COM',
    alpha2: 'KM',
    name: 'Comoros',
  },
  {
    alpha3: 'COG',
    alpha2: 'CG',
    name: 'Congo',
  },
  {
    alpha3: 'COD',
    alpha2: 'CD',
    name: 'Congo, Democratic Republic of the',
  },
  {
    alpha3: 'COK',
    alpha2: 'CK',
    name: 'Cook Islands',
  },
  {
    alpha3: 'CRI',
    alpha2: 'CR',
    name: 'Costa Rica',
  },
  {
    alpha3: 'CIV',
    alpha2: 'CI',
    name: "Côte d'Ivoire",
  },
  {
    alpha3: 'HRV',
    alpha2: 'HR',
    name: 'Croatia',
  },
  {
    alpha3: 'CUB',
    alpha2: 'CU',
    name: 'Cuba',
  },
  {
    alpha3: 'CUW',
    alpha2: 'CW',
    name: 'Curaçao',
  },
  {
    alpha3: 'CYP',
    alpha2: 'CY',
    name: 'Cyprus',
  },
  {
    alpha3: 'CZE',
    alpha2: 'CZ',
    name: 'Czechia',
  },
  {
    alpha3: 'DNK',
    alpha2: 'DK',
    name: 'Denmark',
  },
  {
    alpha3: 'DJI',
    alpha2: 'DJ',
    name: 'Djibouti',
  },
  {
    alpha3: 'DMA',
    alpha2: 'DM',
    name: 'Dominica',
  },
  {
    alpha3: 'DOM',
    alpha2: 'DO',
    name: 'Dominican Republic',
  },
  {
    alpha3: 'ECU',
    alpha2: 'EC',
    name: 'Ecuador',
  },
  {
    alpha3: 'EGY',
    alpha2: 'EG',
    name: 'Egypt',
  },
  {
    alpha3: 'SLV',
    alpha2: 'SV',
    name: 'El Salvador',
  },
  {
    alpha3: 'GNQ',
    alpha2: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    alpha3: 'ERI',
    alpha2: 'ER',
    name: 'Eritrea',
  },
  {
    alpha3: 'EST',
    alpha2: 'EE',
    name: 'Estonia',
  },
  {
    alpha3: 'SWZ',
    alpha2: 'SZ',
    name: 'Eswatini',
  },
  {
    alpha3: 'ETH',
    alpha2: 'ET',
    name: 'Ethiopia',
  },
  {
    alpha3: 'FLK',
    alpha2: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    alpha3: 'FRO',
    alpha2: 'FO',
    name: 'Faroe Islands',
  },
  {
    alpha3: 'FJI',
    alpha2: 'FJ',
    name: 'Fiji',
  },
  {
    alpha3: 'FIN',
    alpha2: 'FI',
    name: 'Finland',
  },
  {
    alpha3: 'FRA',
    alpha2: 'FR',
    name: 'France',
  },
  {
    alpha3: 'GUF',
    alpha2: 'GF',
    name: 'French Guiana',
  },
  {
    alpha3: 'PYF',
    alpha2: 'PF',
    name: 'French Polynesia',
  },
  {
    alpha3: 'ATF',
    alpha2: 'TF',
    name: 'French Southern Territories',
  },
  {
    alpha3: 'GAB',
    alpha2: 'GA',
    name: 'Gabon',
  },
  {
    alpha3: 'GMB',
    alpha2: 'GM',
    name: 'Gambia',
  },
  {
    alpha3: 'GEO',
    alpha2: 'GE',
    name: 'Georgia',
  },
  {
    alpha3: 'DEU',
    alpha2: 'DE',
    name: 'Germany',
  },
  {
    alpha3: 'GHA',
    alpha2: 'GH',
    name: 'Ghana',
  },
  {
    alpha3: 'GIB',
    alpha2: 'GI',
    name: 'Gibraltar',
  },
  {
    alpha3: 'GRC',
    alpha2: 'GR',
    name: 'Greece',
  },
  {
    alpha3: 'GRL',
    alpha2: 'GL',
    name: 'Greenland',
  },
  {
    alpha3: 'GRD',
    alpha2: 'GD',
    name: 'Grenada',
  },
  {
    alpha3: 'GLP',
    alpha2: 'GP',
    name: 'Guadeloupe',
  },
  {
    alpha3: 'GUM',
    alpha2: 'GU',
    name: 'Guam',
  },
  {
    alpha3: 'GTM',
    alpha2: 'GT',
    name: 'Guatemala',
  },
  {
    alpha3: 'GGY',
    alpha2: 'GG',
    name: 'Guernsey',
  },
  {
    alpha3: 'GIN',
    alpha2: 'GN',
    name: 'Guinea',
  },
  {
    alpha3: 'GNB',
    alpha2: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    alpha3: 'GUY',
    alpha2: 'GY',
    name: 'Guyana',
  },
  {
    alpha3: 'HTI',
    alpha2: 'HT',
    name: 'Haiti',
  },
  {
    alpha3: 'HMD',
    alpha2: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    alpha3: 'VAT',
    alpha2: 'VA',
    name: 'Holy See',
  },
  {
    alpha3: 'HND',
    alpha2: 'HN',
    name: 'Honduras',
  },
  {
    alpha3: 'HKG',
    alpha2: 'HK',
    name: 'Hong Kong',
  },
  {
    alpha3: 'HUN',
    alpha2: 'HU',
    name: 'Hungary',
  },
  {
    alpha3: 'ISL',
    alpha2: 'IS',
    name: 'Iceland',
  },
  {
    alpha3: 'IND',
    alpha2: 'IN',
    name: 'India',
  },
  {
    alpha3: 'IDN',
    alpha2: 'ID',
    name: 'Indonesia',
  },
  {
    alpha3: 'IRN',
    alpha2: 'IR',
    name: 'Iran (Islamic Republic of)',
  },
  {
    alpha3: 'IRQ',
    alpha2: 'IQ',
    name: 'Iraq',
  },
  {
    alpha3: 'IRL',
    alpha2: 'IE',
    name: 'Ireland',
  },
  {
    alpha3: 'IMN',
    alpha2: 'IM',
    name: 'Isle of Man',
  },
  {
    alpha3: 'ISR',
    alpha2: 'IL',
    name: 'Israel',
  },
  {
    alpha3: 'ITA',
    alpha2: 'IT',
    name: 'Italy',
  },
  {
    alpha3: 'JAM',
    alpha2: 'JM',
    name: 'Jamaica',
  },
  {
    alpha3: 'JPN',
    alpha2: 'JP',
    name: 'Japan',
  },
  {
    alpha3: 'JEY',
    alpha2: 'JE',
    name: 'Jersey',
  },
  {
    alpha3: 'JOR',
    alpha2: 'JO',
    name: 'Jordan',
  },
  {
    alpha3: 'KAZ',
    alpha2: 'KZ',
    name: 'Kazakhstan',
  },
  {
    alpha3: 'KEN',
    alpha2: 'KE',
    name: 'Kenya',
  },
  {
    alpha3: 'KIR',
    alpha2: 'KI',
    name: 'Kiribati',
  },
  {
    alpha3: 'PRK',
    alpha2: 'KP',
    name: "Korea (Democratic People's Republic of)",
  },
  {
    alpha3: 'KOR',
    alpha2: 'KR',
    name: 'Korea, Republic of',
  },
  {
    alpha3: 'KWT',
    alpha2: 'KW',
    name: 'Kuwait',
  },
  {
    alpha3: 'KGZ',
    alpha2: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    alpha3: 'LAO',
    alpha2: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    alpha3: 'LVA',
    alpha2: 'LV',
    name: 'Latvia',
  },
  {
    alpha3: 'LBN',
    alpha2: 'LB',
    name: 'Lebanon',
  },
  {
    alpha3: 'LSO',
    alpha2: 'LS',
    name: 'Lesotho',
  },
  {
    alpha3: 'LBR',
    alpha2: 'LR',
    name: 'Liberia',
  },
  {
    alpha3: 'LBY',
    alpha2: 'LY',
    name: 'Libya',
  },
  {
    alpha3: 'LIE',
    alpha2: 'LI',
    name: 'Liechtenstein',
  },
  {
    alpha3: 'LTU',
    alpha2: 'LT',
    name: 'Lithuania',
  },
  {
    alpha3: 'LUX',
    alpha2: 'LU',
    name: 'Luxembourg',
  },
  {
    alpha3: 'MAC',
    alpha2: 'MO',
    name: 'Macao',
  },
  {
    alpha3: 'MDG',
    alpha2: 'MG',
    name: 'Madagascar',
  },
  {
    alpha3: 'MWI',
    alpha2: 'MW',
    name: 'Malawi',
  },
  {
    alpha3: 'MYS',
    alpha2: 'MY',
    name: 'Malaysia',
  },
  {
    alpha3: 'MDV',
    alpha2: 'MV',
    name: 'Maldives',
  },
  {
    alpha3: 'MLI',
    alpha2: 'ML',
    name: 'Mali',
  },
  {
    alpha3: 'MLT',
    alpha2: 'MT',
    name: 'Malta',
  },
  {
    alpha3: 'MHL',
    alpha2: 'MH',
    name: 'Marshall Islands',
  },
  {
    alpha3: 'MTQ',
    alpha2: 'MQ',
    name: 'Martinique',
  },
  {
    alpha3: 'MRT',
    alpha2: 'MR',
    name: 'Mauritania',
  },
  {
    alpha3: 'MUS',
    alpha2: 'MU',
    name: 'Mauritius',
  },
  {
    alpha3: 'MYT',
    alpha2: 'YT',
    name: 'Mayotte',
  },
  {
    alpha3: 'MEX',
    alpha2: 'MX',
    name: 'Mexico',
  },
  {
    alpha3: 'FSM',
    alpha2: 'FM',
    name: 'Micronesia (Federated States of)',
  },
  {
    alpha3: 'MDA',
    alpha2: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    alpha3: 'MCO',
    alpha2: 'MC',
    name: 'Monaco',
  },
  {
    alpha3: 'MNG',
    alpha2: 'MN',
    name: 'Mongolia',
  },
  {
    alpha3: 'MNE',
    alpha2: 'ME',
    name: 'Montenegro',
  },
  {
    alpha3: 'MSR',
    alpha2: 'MS',
    name: 'Montserrat',
  },
  {
    alpha3: 'MAR',
    alpha2: 'MA',
    name: 'Morocco',
  },
  {
    alpha3: 'MOZ',
    alpha2: 'MZ',
    name: 'Mozambique',
  },
  {
    alpha3: 'MMR',
    alpha2: 'MM',
    name: 'Myanmar',
  },
  {
    alpha3: 'NAM',
    alpha2: 'NA',
    name: 'Namibia',
  },
  {
    alpha3: 'NRU',
    alpha2: 'NR',
    name: 'Nauru',
  },
  {
    alpha3: 'NPL',
    alpha2: 'NP',
    name: 'Nepal',
  },
  {
    alpha3: 'NLD',
    alpha2: 'NL',
    name: 'Netherlands',
  },
  {
    alpha3: 'NCL',
    alpha2: 'NC',
    name: 'New Caledonia',
  },
  {
    alpha3: 'NZL',
    alpha2: 'NZ',
    name: 'New Zealand',
  },
  {
    alpha3: 'NIC',
    alpha2: 'NI',
    name: 'Nicaragua',
  },
  {
    alpha3: 'NER',
    alpha2: 'NE',
    name: 'Niger',
  },
  {
    alpha3: 'NGA',
    alpha2: 'NG',
    name: 'Nigeria',
  },
  {
    alpha3: 'NIU',
    alpha2: 'NU',
    name: 'Niue',
  },
  {
    alpha3: 'NFK',
    alpha2: 'NF',
    name: 'Norfolk Island',
  },
  {
    alpha3: 'MKD',
    alpha2: 'MK',
    name: 'North Macedonia',
  },
  {
    alpha3: 'MNP',
    alpha2: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    alpha3: 'NOR',
    alpha2: 'NO',
    name: 'Norway',
  },
  {
    alpha3: 'OMN',
    alpha2: 'OM',
    name: 'Oman',
  },
  {
    alpha3: 'PAK',
    alpha2: 'PK',
    name: 'Pakistan',
  },
  {
    alpha3: 'PLW',
    alpha2: 'PW',
    name: 'Palau',
  },
  {
    alpha3: 'PSE',
    alpha2: 'PS',
    name: 'Palestine, State of',
  },
  {
    alpha3: 'PAN',
    alpha2: 'PA',
    name: 'Panama',
  },
  {
    alpha3: 'PNG',
    alpha2: 'PG',
    name: 'Papua New Guinea',
  },
  {
    alpha3: 'PRY',
    alpha2: 'PY',
    name: 'Paraguay',
  },
  {
    alpha3: 'PER',
    alpha2: 'PE',
    name: 'Peru',
  },
  {
    alpha3: 'PHL',
    alpha2: 'PH',
    name: 'Philippines',
  },
  {
    alpha3: 'PCN',
    alpha2: 'PN',
    name: 'Pitcairn',
  },
  {
    alpha3: 'POL',
    alpha2: 'PL',
    name: 'Poland',
  },
  {
    alpha3: 'PRT',
    alpha2: 'PT',
    name: 'Portugal',
  },
  {
    alpha3: 'PRI',
    alpha2: 'PR',
    name: 'Puerto Rico',
  },
  {
    alpha3: 'QAT',
    alpha2: 'QA',
    name: 'Qatar',
  },
  {
    alpha3: 'REU',
    alpha2: 'RE',
    name: 'Réunion',
  },
  {
    alpha3: 'ROU',
    alpha2: 'RO',
    name: 'Romania',
  },
  {
    alpha3: 'RUS',
    alpha2: 'RU',
    name: 'Russian Federation',
  },
  {
    alpha3: 'RWA',
    alpha2: 'RW',
    name: 'Rwanda',
  },
  {
    alpha3: 'BLM',
    alpha2: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    alpha3: 'SHN',
    alpha2: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    alpha3: 'KNA',
    alpha2: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    alpha3: 'LCA',
    alpha2: 'LC',
    name: 'Saint Lucia',
  },
  {
    alpha3: 'MAF',
    alpha2: 'MF',
    name: 'Saint Martin (French part)',
  },
  {
    alpha3: 'SPM',
    alpha2: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    alpha3: 'VCT',
    alpha2: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    alpha3: 'WSM',
    alpha2: 'WS',
    name: 'Samoa',
  },
  {
    alpha3: 'SMR',
    alpha2: 'SM',
    name: 'San Marino',
  },
  {
    alpha3: 'STP',
    alpha2: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    alpha3: 'SAU',
    alpha2: 'SA',
    name: 'Saudi Arabia',
  },
  {
    alpha3: 'SEN',
    alpha2: 'SN',
    name: 'Senegal',
  },
  {
    alpha3: 'SRB',
    alpha2: 'RS',
    name: 'Serbia',
  },
  {
    alpha3: 'SYC',
    alpha2: 'SC',
    name: 'Seychelles',
  },
  {
    alpha3: 'SLE',
    alpha2: 'SL',
    name: 'Sierra Leone',
  },
  {
    alpha3: 'SGP',
    alpha2: 'SG',
    name: 'Singapore',
  },
  {
    alpha3: 'SXM',
    alpha2: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    alpha3: 'SVK',
    alpha2: 'SK',
    name: 'Slovakia',
  },
  {
    alpha3: 'SVN',
    alpha2: 'SI',
    name: 'Slovenia',
  },
  {
    alpha3: 'SLB',
    alpha2: 'SB',
    name: 'Solomon Islands',
  },
  {
    alpha3: 'SOM',
    alpha2: 'SO',
    name: 'Somalia',
  },
  {
    alpha3: 'ZAF',
    alpha2: 'ZA',
    name: 'South Africa',
  },
  {
    alpha3: 'SGS',
    alpha2: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    alpha3: 'SSD',
    alpha2: 'SS',
    name: 'South Sudan',
  },
  {
    alpha3: 'ESP',
    alpha2: 'ES',
    name: 'Spain',
  },
  {
    alpha3: 'LKA',
    alpha2: 'LK',
    name: 'Sri Lanka',
  },
  {
    alpha3: 'SDN',
    alpha2: 'SD',
    name: 'Sudan',
  },
  {
    alpha3: 'SUR',
    alpha2: 'SR',
    name: 'Suriname',
  },
  {
    alpha3: 'SJM',
    alpha2: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    alpha3: 'SWE',
    alpha2: 'SE',
    name: 'Sweden',
  },
  {
    alpha3: 'CHE',
    alpha2: 'CH',
    name: 'Switzerland',
  },
  {
    alpha3: 'SYR',
    alpha2: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    alpha3: 'TWN',
    alpha2: 'TW',
    name: 'Taiwan, Province of China',
  },
  {
    alpha3: 'TJK',
    alpha2: 'TJ',
    name: 'Tajikistan',
  },
  {
    alpha3: 'TZA',
    alpha2: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    alpha3: 'THA',
    alpha2: 'TH',
    name: 'Thailand',
  },
  {
    alpha3: 'TLS',
    alpha2: 'TL',
    name: 'Timor-Leste',
  },
  {
    alpha3: 'TGO',
    alpha2: 'TG',
    name: 'Togo',
  },
  {
    alpha3: 'TKL',
    alpha2: 'TK',
    name: 'Tokelau',
  },
  {
    alpha3: 'TON',
    alpha2: 'TO',
    name: 'Tonga',
  },
  {
    alpha3: 'TTO',
    alpha2: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    alpha3: 'TUN',
    alpha2: 'TN',
    name: 'Tunisia',
  },
  {
    alpha3: 'TUR',
    alpha2: 'TR',
    name: 'Turkey',
  },
  {
    alpha3: 'TKM',
    alpha2: 'TM',
    name: 'Turkmenistan',
  },
  {
    alpha3: 'TCA',
    alpha2: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    alpha3: 'TUV',
    alpha2: 'TV',
    name: 'Tuvalu',
  },
  {
    alpha3: 'UGA',
    alpha2: 'UG',
    name: 'Uganda',
  },
  {
    alpha3: 'UKR',
    alpha2: 'UA',
    name: 'Ukraine',
  },
  {
    alpha3: 'ARE',
    alpha2: 'AE',
    name: 'United Arab Emirates',
  },
  {
    alpha3: 'GBR',
    alpha2: 'GB',
    name: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    alpha3: 'USA',
    alpha2: 'US',
    name: 'United States of America',
  },
  {
    alpha3: 'UMI',
    alpha2: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    alpha3: 'URY',
    alpha2: 'UY',
    name: 'Uruguay',
  },
  {
    alpha3: 'UZB',
    alpha2: 'UZ',
    name: 'Uzbekistan',
  },
  {
    alpha3: 'VUT',
    alpha2: 'VU',
    name: 'Vanuatu',
  },
  {
    alpha3: 'VEN',
    alpha2: 'VE',
    name: 'Venezuela (Bolivarian Republic of)',
  },
  {
    alpha3: 'VNM',
    alpha2: 'VN',
    name: 'Viet Nam',
  },
  {
    alpha3: 'VGB',
    alpha2: 'VG',
    name: 'Virgin Islands (British)',
  },
  {
    alpha3: 'VIR',
    alpha2: 'VI',
    name: 'Virgin Islands (U.S.)',
  },
  {
    alpha3: 'WLF',
    alpha2: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    alpha3: 'ESH',
    alpha2: 'EH',
    name: 'Western Sahara',
  },
  {
    alpha3: 'YEM',
    alpha2: 'YE',
    name: 'Yemen',
  },
  {
    alpha3: 'ZMB',
    alpha2: 'ZM',
    name: 'Zambia',
  },
  {
    alpha3: 'ZWE',
    alpha2: 'ZW',
    name: 'Zimbabwe',
  },
]

export default countryCodes
